export const maxImageFileSize = 5242880
export const env = {
  CONTROL: 'control',
  DESTINATION: 'destination'
}
